import connectAsync from '../../../utils/connectAsync';
import fetchMeAndProducts from '../../../utils/connectors/fetchMeAndProducts';
import fetchPartnerAndPair from '../../../utils/connectors/fetchPartnerAndPair';
import OauthAuthConfirmationRoute from './OauthConfirmationRoute';

export default connectAsync([fetchMeAndProducts, fetchPartnerAndPair])(OauthAuthConfirmationRoute);
